import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.5 5H10.5C10.6326 5 10.7598 4.94732 10.8536 4.85355C10.9473 4.75979 11 4.63261 11 4.5C11 4.36739 10.9473 4.24021 10.8536 4.14645C10.7598 4.05268 10.6326 4 10.5 4H6.5C6.36739 4 6.24021 4.05268 6.14645 4.14645C6.05268 4.24021 6 4.36739 6 4.5C6 4.63261 6.05268 4.75979 6.14645 4.85355C6.24021 4.94732 6.36739 5 6.5 5Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.5 6H6.5C6.36739 6 6.24021 6.05268 6.14645 6.14645C6.05268 6.24021 6 6.36739 6 6.5C6 6.63261 6.05268 6.75979 6.14645 6.85355C6.24021 6.94732 6.36739 7 6.5 7H8.5C8.63261 7 8.75979 6.94732 8.85355 6.85355C8.94732 6.75979 9 6.63261 9 6.5C9 6.36739 8.94732 6.24021 8.85355 6.14645C8.75979 6.05268 8.63261 6 8.5 6Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.5001 12C12.6327 12 12.7598 11.9473 12.8536 11.8536C12.9474 11.7598 13.0001 11.6326 13.0001 11.5V2.5C13.0001 2.36739 12.9474 2.24022 12.8536 2.14645C12.7598 2.05268 12.6327 2 12.5001 2H4.50006C4.3045 1.99601 4.11012 2.03108 3.92829 2.10317C3.74647 2.17525 3.58086 2.2829 3.44116 2.4198C3.30147 2.5567 3.1905 2.72011 3.11475 2.90044C3.03901 3.08077 3.00002 3.27441 3.00006 3.47V12.47C2.99607 12.6695 3.03192 12.8678 3.10551 13.0532C3.1791 13.2387 3.28896 13.4076 3.42865 13.5501C3.56833 13.6926 3.73504 13.8058 3.91902 13.883C4.10299 13.9603 4.30052 14 4.50006 14H12.5001C12.6327 14 12.7598 13.9473 12.8536 13.8536C12.9474 13.7598 13.0001 13.6326 13.0001 13.5C13.0001 13.3674 12.9474 13.2402 12.8536 13.1464C12.7598 13.0527 12.6327 13 12.5001 13C12.3674 13 12.2403 12.9473 12.1465 12.8536C12.0527 12.7598 12.0001 12.6326 12.0001 12.5C12.0001 12.3674 12.0527 12.2402 12.1465 12.1464C12.2403 12.0527 12.3674 12 12.5001 12ZM12.0001 11H5.00006V3H12.0001V11ZM4.50006 13C4.36745 13 4.24027 12.9473 4.1465 12.8536C4.05273 12.7598 4.00006 12.6326 4.00006 12.5C4.00006 12.3674 4.05273 12.2402 4.1465 12.1464C4.24027 12.0527 4.36745 12 4.50006 12H11.0901C10.9697 12.3225 10.9697 12.6775 11.0901 13H4.50006Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
